import { CollateralBasketType, CollateralBasketTypePermissions, collateralBasketTypePermissions, SettlementVenue } from 'api'

const createBasketTypePermissionPredicate = (permissionType: keyof CollateralBasketTypePermissions) => (
  basketType: CollateralBasketType
) => {
  return collateralBasketTypePermissions[basketType][permissionType]
}

export const isTriParty = (basketType: CollateralBasketType) => {
  const settlementVenues = collateralBasketTypePermissions[basketType].settlementVenues

  return settlementVenues.includes(SettlementVenue.Triparty)
}

export const isBasketTypePermittedToBePrimary = createBasketTypePermissionPredicate('permittedToBePrimary')
export const isBasketPermittedToBeSblSecondary = createBasketTypePermissionPredicate('basketPermittedToBeSblSecondary')
export const doesBasketTypeRequiresTradingEntityPermission = createBasketTypePermissionPredicate('requiresTradingEntityPermission')
